import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../services/user.service';
import { APP_ROUTES } from '@app/app-routes.const';

export const NonAuthGuard: CanActivateFn = () => {
  const userSrv = inject(UserService);
  const router = inject(Router);

  if (!userSrv.isLoggedIn()) {
    return true;
  }

  return router.parseUrl(`/${APP_ROUTES.HOME}`);
};
